import {
  Thermometer, Droplets, Gauge, Wind, Compass, Zap, CloudRain, CalendarDays,
  Sun as SunIcon, SunMedium, Droplet, Flame, Snowflake,
} from "lucide-react";
import MetricCard from "@/components/MetricCard";
import { windDirection } from "@/lib/weatherUtils";

export default function DashboardGrid({ data }) {
  if (!data) return null;

  const metrics = [
    { key: "temperature", label: "Temperatura", value: data.temperature, unit: "°C", icon: Thermometer, accent: "#EF4444" },
    { key: "humidity", label: "Umidità", value: data.humidity, unit: "%", icon: Droplets, accent: "#0EA5E9" },
    { key: "pressure", label: "Pressione", value: data.pressure, unit: "hPa", icon: Gauge, accent: "#8B5CF6" },
    { key: "wind_speed", label: "Vento", value: data.wind_speed, unit: "km/h", icon: Wind, accent: "#22C55E" },
    { key: "wind_direction", label: "Direzione vento", value: windDirection(data.wind_direction), unit: `${Math.round(data.wind_direction)}°`, icon: Compass, accent: "#0B132B" },
    { key: "wind_gust", label: "Raffica massima", value: data.wind_gust, unit: "km/h", icon: Zap, accent: "#FBBF24" },
    { key: "rain_day", label: "Pioggia giornaliera", value: data.rain_day, unit: "mm", icon: CloudRain, accent: "#0EA5E9" },
    { key: "rain_month", label: "Pioggia mensile", value: data.rain_month, unit: "mm", icon: CalendarDays, accent: "#0EA5E9" },
    { key: "uv", label: "Indice UV", value: data.uv, unit: "", icon: SunIcon, accent: "#F97316" },
    { key: "solar", label: "Radiazione solare", value: data.solar, unit: "W/m²", icon: SunMedium, accent: "#FBBF24" },
    { key: "dew_point", label: "Dew Point", value: data.dew_point, unit: "°C", icon: Droplet, accent: "#0EA5E9" },
    { key: "heat_index", label: "Heat Index", value: data.heat_index, unit: "°C", icon: Flame, accent: "#EF4444" },
    { key: "wind_chill", label: "Wind Chill", value: data.wind_chill, unit: "°C", icon: Snowflake, accent: "#0EA5E9" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-testid="dashboard-grid">
      {metrics.map((m, i) => (
        <MetricCard
          key={m.key}
          label={m.label}
          value={m.value}
          unit={m.unit}
          icon={m.icon}
          accent={m.accent}
          testId={`metric-${m.key}`}
          delay={i * 0.04}
        />
      ))}
    </div>
  );
}
